import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { errors } from '@ocean/ui'
import { history } from 'store'
import { InitializationLayer, UserDeclarationLayer, CommunicationIFrameLayer } from 'core/layers'
import { ApplicationError } from 'components/errors'
import { routes as authRoutes } from 'modules/Auth/routing'
import { routes as ssoRoutes } from 'modules/Sso/routing'
import StatusRouting, { routes as statusRoutes } from 'modules/Status/routing'
import MobileNativeRedirectRouting, {
  routes as mobileNativeRedirectRoutes,
} from 'modules/redirects/MobileNativeRedirect/routing'
import ProxyRedirectRouting, {
  routes as proxyRedirectRoutes,
} from 'modules/redirects/ProxyRedirect/routing'
import StaRedirectRouting, {
  routes as staRedirectRoutes,
} from 'modules/redirects/StaRedirect/routing'
import ExternalRouting from './ExternalRouting'
import PrivateRouting from './PrivateRouting'
import rootRoutes from './routes'

const { ErrorBoundary } = errors

const RootRouting = () => {
  return (
    <ConnectedRouter history={history}>
      <ErrorBoundary FallbackComponent={ApplicationError}>
        <InitializationLayer>
          <UserDeclarationLayer>
            <CommunicationIFrameLayer>
              <Switch>
                <Route path={staRedirectRoutes.root} component={StaRedirectRouting} />
                <Route path={proxyRedirectRoutes.root} component={ProxyRedirectRouting} />
                <Route
                  path={mobileNativeRedirectRoutes.root}
                  component={MobileNativeRedirectRouting}
                />
                <Route path={statusRoutes.root} component={StatusRouting} />
                <Route path={authRoutes.root} component={ExternalRouting} />
                <Route path={ssoRoutes.root} component={ExternalRouting} />
                <Route path={rootRoutes.root} component={PrivateRouting} />
              </Switch>
            </CommunicationIFrameLayer>
          </UserDeclarationLayer>
        </InitializationLayer>
      </ErrorBoundary>
    </ConnectedRouter>
  )
}

export default RootRouting
